import React from "react";
import Menu from "../components/navbar.js";

export function SampleAnalyses() {
    <Menu/> 
    return <h1>Coming Soon!</h1>
}